module.exports = __webpack_public_path__ + "img/plant_0_small.24f2f95c.webp";